import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

interface PageErrorPanelProps {
  error: Error;
  /** A safe signed-in destination: the seller's Home when there is one. */
  homeTo: string;
  onRetry: () => void;
}

/** Spec S00's page error panel: "This page hit an error", Go to Home / Back. */
export function PageErrorPanel({ error, homeTo, onRetry }: PageErrorPanelProps) {
  const navigate = useNavigate();
  // A page opened directly has nothing to go back to; Home is the way out then.
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate(homeTo));
  return (
    <section role="alert" className="rounded-card border-line bg-panel border">
      <div className="border-line border-b px-3.5 py-3">
        <h2 className="font-display text-[14.5px] font-semibold">This page hit an error</h2>
      </div>
      <div className="flex flex-col gap-2 p-3.5">
        <p className="text-muted">Merx caught it, so the rest of the app keeps working.</p>
        <p className="text-muted break-words font-mono text-xs">{error.message.slice(0, 200)}</p>
        <div className="flex flex-wrap items-center gap-2 pt-1">
          <Link
            to={homeTo}
            className="bg-ink hover:bg-navy3 inline-flex items-center rounded px-3.5 py-2 text-sm font-medium text-white"
          >
            Go to Home
          </Link>
          <Button variant="secondary" onClick={back}>
            Back
          </Button>
          <Button variant="secondary" onClick={onRetry}>
            Try again
          </Button>
        </div>
      </div>
    </section>
  );
}
